export default {
  common: {
    nav: {
      home: "હોમ",
      find_offer_help: "મદદ શોધો / આપો",
      celebrate: "જીવન ઉજવો",
      family_tree: "કુટુંબ વૃક્ષ",
      events: "કાર્યક્રમો",
      civic_reports: "નાગરિક અહેવાલો",
      neighborhood_pulse: "પડોશની ધબકાર",
      weather: "હવામાન",
      nature: "કુદરત",
      marketplace: "બજાર",
      news: "સમાચાર",
      causes: "ઉદ્દેશો",
      more: "વધુ",
    },
    header: { sign_in: "સાઇન ઇન", join: "Social Pulse માં જોડાઓ", language: "ભાષા", search: "શોધ" },
    tagline: "સમુદાયોને જોડવું · જીવનને સશક્ત કરવું · સામાજિક મૂડી બનાવવી",
    locality: { viewing_from: "તમે જોઈ રહ્યા છો", change: "બદલો", set_your_location: "તમારું સ્થાન સેટ કરો" },
    news: { title: "તમારું દૈનિક બ્રિફિંગ.", play_briefing: "દૈનિક બ્રિફિંગ ચલાવો", listen: "સાંભળો", translate: "અનુવાદ કરો" },
  },
};
